import { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const [consent, setConsent] = useState(() => {
    try {
      return localStorage.getItem("svx_consent");
    } catch (e) {
      return "all";
    }
  });

  if (consent || isAdmin) return null;

  const decide = (value) => {
    try {
      localStorage.setItem("svx_consent", value);
    } catch (e) {}
    window.dispatchEvent(new Event("svx-consent-changed"));
    setConsent(value);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1.2 }}
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[95] glass-strong rounded-2xl p-5"
      data-testid="cookie-consent-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-accent-bright shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-white mb-1">We value your privacy</p>
          <p className="text-xs text-mist leading-relaxed mb-4">
            We use cookies for essential site functions and — only with your consent — analytics to understand how the site is used.
          </p>
          <div className="flex flex-wrap gap-2.5">
            <button
              onClick={() => decide("all")}
              className="px-4 py-2 rounded-full bg-accent hover:bg-accent-bright text-white text-xs font-semibold transition-colors"
              data-testid="cookie-accept-all-btn"
            >
              Accept All
            </button>
            <button
              onClick={() => decide("essential")}
              className="px-4 py-2 rounded-full border border-white/15 text-mist hover:text-white hover:border-white/30 text-xs font-semibold transition-colors"
              data-testid="cookie-reject-nonessential-btn"
            >
              Reject Non-Essential
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
